/**
 * Function that creates the menu logic for the header
 */
export function primaryNav() {
  const activeClass = 'is-active';
  const $hamburger = $( '.a__hamburger' );
  const $menu = $( '.m__primary-nav-menu-container' );
  const $usernameNav = $( '.m__user-nav-username' );
  const $userMenu = $( '.m__user-menu' );
  const cssDisplay = 'display';
  const cssDisplayBlock = 'block';
  const cssDisplayNone = 'none';

  $hamburger.on( 'click', function toggle() {
    $hamburger.toggleClass( activeClass );
    $menu.toggleClass( activeClass );
  });

  $usernameNav.click( function toggleUserMenu() {
    const displayValue = $userMenu.css( 'display' );
    $userMenu.css( cssDisplay, displayValue === cssDisplayNone ? cssDisplayBlock : cssDisplayNone );
  });

  $usernameNav.mouseenter( function displayUserMenu() {
    $userMenu.css( cssDisplay, cssDisplayBlock );
  });

  $userMenu.mouseleave( function hideUserMenu() {
    $( this ).css( cssDisplay, cssDisplayNone );
  });
}